import * as React from 'react'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'

type Props = {
  children: React.ReactNode
}

export function EmptyCard(props: Props) {
  const { children } = props

  return (
    <Card elevation={2}>
      <Box width="320px" minHeight="100px" p={0.8}>
        {children}
      </Box>
    </Card>
  )
}
